import type { SVGProps } from 'react';

export const Level = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.65 19.5a1.17 1.17 0 0 1-.825-.325 1.172 1.172 0 0 1-.325-.825v-2.7c0-.317.108-.583.325-.8.233-.233.508-.35.825-.35.317 0 .583.117.8.35.233.217.35.483.35.8v2.7c0 .317-.117.592-.35.825a1.087 1.087 0 0 1-.8.325Zm5.9 0a1.17 1.17 0 0 1-.825-.325 1.172 1.172 0 0 1-.325-.825v-7.7c0-.317.108-.583.325-.8.233-.233.508-.35.825-.35.333 0 .608.117.825.35.217.217.325.483.325.8v7.7c0 .317-.108.592-.325.825a1.118 1.118 0 0 1-.825.325Zm5.8 0a1.17 1.17 0 0 1-.825-.325 1.172 1.172 0 0 1-.325-.825V5.65c0-.317.108-.583.325-.8.233-.233.508-.35.825-.35.317 0 .583.117.8.35.233.217.35.483.35.8v12.7c0 .317-.117.592-.35.825a1.087 1.087 0 0 1-.8.325Z" />
    </svg>
  );
};
